<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-button type="primary" style="margin-left: 40px;" @click="addGoodsOpenBtn('')">添加额外积分</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="days"
            label="天数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="integral"
            label="积分数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="addGoodsOpenBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 添加额外签到积分弹窗 -->
    <el-dialog
      title="添加额外签到积分"
      :visible.sync="addGoodsShow"
      width="960px">
      <el-form :model="oneForm" :rules="rules" label-width="140px">
        <el-form-item label="天数：" prop="day">
          <el-select style="width: 420px;" v-model="oneForm.day" placeholder="请选择天数">
            <el-option v-for="(item,index) in dayList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="积分：" prop="number">
          <el-input style="width: 420px;" v-model="oneForm.number" placeholder="请输入积分数量"></el-input>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <el-switch
            v-model="oneForm.status"
            active-color="#13ce66"
            inactive-color="#CCCCCC">
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryIntegralExtraPageList, saveIntegralExtra, updateIntegralExtra, fetchIntegralExtraDetailById, removeIntegralExtraById, enableIntegralExtraById, getIntegralDays } from '@/api/integral'
export default {
  name: 'IntegralExtraCheckIn',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      // 添加额外签到积分弹窗
      infoId:'',
      addGoodsShow:false,
      dayList:[],
      oneForm:{
        day:'',
        number:'',
        status:false
      },
      rules: {
        day: [
          { required: true, message: '请选择天数', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入积分数量', trigger: 'blur' }
        ]
      },
    }
  },
  mounted () {
    this.getInfoList()
  },
  created() {
    var that = this;
    getIntegralDays({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.dayList = data;
      }
    })
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let page = that.currentPage
      queryIntegralExtraPageList({ pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 添加额外签到积分弹窗-打开弹窗操作 */
    addGoodsOpenBtn (infoId) {
      this.oneForm.day = '';
      this.oneForm.number = '';
      this.oneForm.status = false;
      this.infoId = infoId;
      let that = this
      if(infoId == ''){
        that.addGoodsShow = true;
      }else{
        fetchIntegralExtraDetailById({ id: infoId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.oneForm.day = data.days;
            that.oneForm.number = data.integral;
            that.oneForm.status = data.status == 1 ? true : false;
            that.addGoodsShow = true;
          }else{
            that.$message.error(res.msg);
          }
        })
      }
    },
    // 添加额外签到积分弹窗-保存操作
    saveBtn(){
      var that = this
      var infoId = that.infoId
      var day = that.oneForm.day
      var number = that.oneForm.number
      let status = that.oneForm.status ? 1 : 0
      if (day === '') {
        this.$message.error('请选择天数')
        return false
      }
      if (number === '') {
        this.$message.error('请输入积分数量')
        return false
      }
      let passData = {
        days: day, integral: number, status:status
      }
      that.fullscreenLoading = true;
      if(infoId == ''){
        saveIntegralExtra(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        passData.id = infoId;
        updateIntegralExtra(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this
      that.fullscreenLoading = false;
      if(res.errorCode == "0000"){
        that.$message.success(res.msg);
        that.oneForm.day = '';
        that.oneForm.number = '';
        that.oneForm.status = false;
        that.addGoodsShow = false;
        that.getInfoList();
      }
      if(res.errorCode == "1001"){
        that.$message.error(res.msg);
      }
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enableIntegralExtraById({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeIntegralExtraById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/integralMall/ExtraCheckIn.vue